import { Injectable } from "@angular/core";
import { DialogIdentifier } from "@bca-shared/models/_enums";
import { IProduct } from "@bca-shared/models/product";
import { IRootState } from "@bca-store/store.reducers";
import {
  selectTotalProductCount
} from "@bca-store/store.selectors";

import { TabComponent } from "@bca-flow/bca-flow-window/tab-stepper/tab/tab.component";
import { environment } from "@environments/environment";
import { select, Store } from "@ngrx/store";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { combineLatest, map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class UIService {
  public readonly nextPageClicked$ = new Subject<void>();
  public readonly tabClicked$ = new Subject<TabComponent>();
  public readonly addProductClicked$ = new Subject<void>();
  public readonly editProductClicked$ = new Subject<IProduct>();
  public readonly allowNewProduct$ = new BehaviorSubject<boolean>(true);
  public readonly showMobileReceiptFooter$ = new BehaviorSubject<boolean>(true);
  private storageSub = new BehaviorSubject<boolean>(false);
  private selectedProduct: IProduct;
  constructor(private _store$: Store<IRootState>) {
    const { allowNewProduct$, showMobileReceiptFooter$ } = this;
    this._store$
      .pipe(
        select(({ app }) => app.dialogStatus),
        combineLatest(
          this._store$.pipe(select(selectTotalProductCount)),
          this._store$.pipe(
            select(selectTotalProductCount),
            map((count) => count >= environment.receipt.maxBuyableProducts),
          ),
        ),
      )
      .subscribe(([dialogStatus, totalProductCount, hasMaximumProducts]) => {
        const isReceiptDialogOpened = dialogStatus[DialogIdentifier.Receipt];
        showMobileReceiptFooter$.next(
          !isReceiptDialogOpened && totalProductCount > 0,
        );
        allowNewProduct$.next(!hasMaximumProducts);
      });
  }

  watchStorage(): Observable<any> {
    return this.storageSub.asObservable();
  }

  getUserStorage(): void {
    const userDataStorage = JSON.parse(
      window.sessionStorage[`${environment.storageKeySerializer}_userData`],
    ).selectedProduct;
    this.storageSub.next(userDataStorage);
  }

  isIgnoreNumbersInLastName(event: KeyboardEvent): boolean {
    event = event ? event : event;
    const charCode = event.charCode
      ? event.charCode
      : event.keyCode
        ? event.keyCode
        : event.which
          ? event.which
          : 0;
    const isNotLetter = charCode > 47 && charCode < 58;
    return !isNotLetter;
  }

  isOnlyLettersInInitials(event: KeyboardEvent): boolean {
    event = event ? event : event;
    const charCode = event.charCode
      ? event.charCode
      : event.keyCode
        ? event.keyCode
        : event.which
          ? event.which
          : 0;
    const isNotLetter =
      charCode > 31 &&
      (charCode < 65 || charCode > 90) &&
      (charCode < 97 || charCode > 122);
    return !isNotLetter;
  }
}
